import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_VISITA_ORAL = gql`
  mutation saveVisitaOral($input: AddVisitaOralInput!) {
    saveVisitaOral(input: $input) {
      idVisita
      idVisitaOral
    }
  }
`;

export default SAVE_VISITA_ORAL;

export const adaptAddVisitaOralInput = (data) => ({
  idVisitaOral: data?.idVisitaOral,
  idComboRIValorKarnofsky: data?.idComboRIValorKarnofsky,
  justificacionModificacion: data?.justificacionModificacion,
  indicacionComentario: data?.indicacionComentario,
  caloricoTotal: data?.caloricoTotal,
  caloricoSO: data?.caloricoSO,
  porcentajeSO: data?.porcentajeSO,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});